import { SeuConfigInputItem } from './config.type';

export type SeuSiloTypeAdditives =
  | 'ADDITIVE_SOLID'
  | 'ADDITIVE_LIQUID'
  | 'ADDITIVE_BIGBAG';

export const SEU_SILO_TYPE_ADDITIVES: Set<SeuSiloType> = new Set([
  'ADDITIVE_SOLID',
  'ADDITIVE_LIQUID',
  'ADDITIVE_BIGBAG',
]);

export type SeuSiloTypeResidues =
  | 'RESIDUE_SOLID'
  | 'RESIDUE_LIQUID'
  | 'RESIDUE_BIGBAG';

export const SEU_SILO_TYPE_RESIDUES: Set<SeuSiloType> = new Set([
  'RESIDUE_SOLID',
  'RESIDUE_LIQUID',
  'RESIDUE_BIGBAG',
]);

export type SeuSiloType = SeuSiloTypeAdditives | SeuSiloTypeResidues;

export type SeuSilo = {
  type: SeuSiloType;
  label: string;
  values: SeuConfigInputItem[];
};
